export type PlanningViewMode = 'dag' | 'week' | 'maand';

interface ViewModeSelectorProps {
  viewMode: PlanningViewMode;
  onViewModeChange: (mode: PlanningViewMode) => void;
}

const MODES: { value: PlanningViewMode; label: string }[] = [
  { value: 'dag', label: 'Dag' },
  { value: 'week', label: 'Week' },
  { value: 'maand', label: 'Maand' },
];

export function ViewModeSelector({ viewMode, onViewModeChange }: ViewModeSelectorProps) {
  return (
    <div className="inline-flex rounded-lg border border-gray-200 p-1 bg-gray-50">
      {MODES.map(({ value, label }) => (
        <button
          key={value}
          type="button"
          onClick={() => onViewModeChange(value)}
          className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${
            viewMode === value
              ? 'bg-white shadow-sm text-gray-900'
              : 'text-gray-500 hover:text-gray-700'
          }`}
          aria-pressed={viewMode === value}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
